import { Close } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import TrackingDomainsPanel from "./TrackingDomainsPanel";

interface TrackingDomainsDialogProps {
  open: boolean;
  onClose: () => void;
  companyId: string;
  getToken: () => Promise<string>;
}

const TrackingDomainsDialog: React.FC<TrackingDomainsDialogProps> = ({
  open,
  onClose,
  companyId,
  getToken,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">Custom Tracking Domains</Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <TrackingDomainsPanel
          companyId={companyId}
          getToken={getToken}
          title="Custom Tracking Domains"
          description="Custom tracking domains allow you to use your own branded subdomain (e.g., track.yourbrand.com) for email open and click tracking. This improves deliverability and builds trust by showing branded links instead of third-party URLs."
          addButtonLabel="Add Tracking Domain"
          emptyMessage="No tracking domains configured"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TrackingDomainsDialog;
